/**
 * CIPAA Status Chip Component
 *
 * Displays the status of a CIPAA election with appropriate color.
 */

import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { CipaaStatus, CIPAA_STATUS_LABELS, CIPAA_STATUS_COLORS } from '../../../types/cipaa';

interface CipaaStatusChipProps extends Omit<ChipProps, 'color' | 'label'> {
  status: CipaaStatus;
}

export const CipaaStatusChip: React.FC<CipaaStatusChipProps> = ({ status, ...props }) => {
  return (
    <Chip
      label={CIPAA_STATUS_LABELS[status] || status}
      color={CIPAA_STATUS_COLORS[status] || 'default'}
      size="small"
      {...props}
    />
  );
};

export default CipaaStatusChip;
